export default "__VITE_ASSET__sz8svsFU__"